function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "200 200 650 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(33.33 0 0 33.33 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -12)",
    d: "M 24 0 L 24 24 L 0 24 L 0 0 L 24 0 Z M 12.5934901 23.257841 L 12.5819402 23.2595131 L 12.5108777 23.2950439 L 12.4918791 23.2987469 L 12.4918791 23.2987469 L 12.4767152 23.2950439 L 12.4056548 23.2595131 C 12.3958229 23.2563662 12.3870493 23.2590235 12.3821421 23.2649074 L 12.3780323 23.275831 L 12.360941 23.7031097 L 12.3658947 23.7234994 L 12.3769048 23.7357139 L 12.4804777 23.8096931 L 12.4953491 23.8136134 L 12.4953491 23.8136134 L 12.5071152 23.8096931 L 12.6106902 23.7357139 L 12.6232938 23.7196733 L 12.6232938 23.7196733 L 12.6266527 23.7031097 L 12.609561 23.275831 C 12.6075724 23.2657013 12.6010112 23.2592993 12.5934901 23.257841 L 12.5934901 23.257841 Z M 12.8583906 23.1452862 L 12.8445485 23.1473072 L 12.6598443 23.2396597 L 12.6498822 23.2499052 L 12.6498822 23.2499052 L 12.6471943 23.2611114 L 12.6650943 23.6906389 L 12.6699349 23.7034178 L 12.6699349 23.7034178 L 12.678386 23.7104931 L 12.8793402 23.8032389 C 12.8914285 23.8068999 12.9022333 23.8029875 12.9078286 23.7952264 L 12.9118235 23.7811639 L 12.8776777 23.1665331 C 12.8752882 23.1545897 12.8674102 23.1470016 12.8583906 23.1452862 L 12.8583906 23.1452862 Z M 12.1430473 23.1473072 C 12.1332178 23.1423925 12.1221763 23.1452606 12.1156365 23.1525954 L 12.1099173 23.1665331 L 12.0757714 23.7811639 C 12.0751323 23.7926639 12.0828099 23.8018602 12.0926481 23.8045676 L 12.108256 23.8032389 L 12.3092106 23.7104931 L 12.3186497 23.7024347 L 12.3186497 23.7024347 L 12.3225043 23.6906389 L 12.340401 23.2611114 L 12.337245 23.2485176 L 12.337245 23.2485176 L 12.3277531 23.2396597 L 12.1430473 23.1473072 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(33.33 0 0 33.33 540 523.33)",
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -11.5)",
    d: "M 13 13 C 15.2091 13 17 14.7909 17 17 L 17 18.5 C 17 19.3284 16.3284 20 15.5 20 L 3.5 20 C 2.67157 20 2 19.3284 2 18.5 L 2 17 C 2 14.7909 3.79086 13 6 13 L 13 13 Z M 19 13.0002 C 20.6569 13.0002 22 14.3434 22 16.0002 L 22 17.5002 C 22 18.3287 21.3284 19.0002 20.5 19.0002 L 19 19.0002 L 19 17 C 19 15.3645 18.2148 13.9125 17.0008 13.0002 L 19 13.0002 Z M 9.5 3 C 11.9853 3 14 5.01472 14 7.5 C 14 9.98528 11.9853 12 9.5 12 C 7.01472 12 5 9.98528 5 7.5 C 5 5.01472 7.01472 3 9.5 3 Z M 18 6 C 19.6569 6 21 7.34315 21 9 C 21 10.6569 19.6569 12 18 12 C 16.3431 12 15 10.6569 15 9 C 15 7.34315 16.3431 6 18 6 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAvatar);
export default __webpack_public_path__ + "static/media/TeamAvatar.4da576ec.svg";
export { ForwardRef as ReactComponent };